import React, {Component} from 'react';
import SimpleTimeField from 'react-simple-timefield';
import {Input} from 'semantic-ui-react';

import './timeField.scss';

class TimeField extends Component {
  render() {
    const {'input': {name, value, onChange, onFocus, onBlur}, 'meta': {touched, error}, ...custom} = this.props;
    const className = touched && error ? 'invalid' : '';

    return (
      <div className='form-time-field'>
        <SimpleTimeField
          name={name}
          value={value}
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
          input={<Input icon='time' size='small' {...custom} />}
          className={className}
        />
        {touched && (error && <span className='error-message'>{error}</span>)}
      </div>
    );
  }
}

export default TimeField;
